import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-input-2/lib/style.css';
import './App.scss';
import Routers from './routers';
function App() {
    return (
        <>
            <Routers />
            <ToastContainer position="bottom-center" />
        </>
    );
}

export default App;
